import { MutationTree } from 'vuex';
import { DOE } from './mutation-types';
import { DoeState } from './state';
import { DOEDTO } from '@/models/DOEDTO';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';

export const mutations: MutationTree<DoeState> = {
    [DOE.SET_IS_LOADING](state, isLoading: boolean) {
        state.isDoeLoading = isLoading;
    },
    [DOE.SET_PDF_IS_LOADING](state, isLoading: boolean) {
        state.isPdfLoading = isLoading;
    },
    [DOE.SET_ITEM](state, does: DOEDTO[]) {
        state.does = does;
    },
    [DOE.SET_NB_ITEMS](state, count: number) {
        state.count = count;
    },
    [DOE.RESET_ITEMS](state) {
        state.does = [];
        state.count = 0;
        state.page = 0;
    },
    [DOE.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [DOE.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [DOE.SET_NB_OF_PAGES](state, nb: number) {
        state.nbOfPages = nb;
    },
    [DOE.ADD_ITEMS](state, does: DOEDTO[]) {
        state.does = [...state.does, ...does];
    },
    [DOE.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return[...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
};
